// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs_wrapper__NBhjA {
  display: flex;
  align-items: center;
}

.breadcrumbs_homeIcon__07Fsb {
  scale: 0.85;
  fill: var(--mui-palette-grey-800);
}

.breadcrumbs_itemLabel__YMmC4 {
  color: var(--mui-palette-grey-800);
  margin-top: 3px;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  letter-spacing: 0.15px;
}

@media only screen and (max-width: 768px) {
  .breadcrumbs_itemLabel__YMmC4 {
    font-size: 12px;
    line-height: 14px;
  }
}

.breadcrumbs_defaultLink__TXzi8 {
  cursor: pointer;
}

.breadcrumbs_breadcrumbSeparator__mNu3A {
  font-size: 16px;
  line-height: 16px;
  color: var(--mui-palette-grey-800);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/breadcrumbs/breadcrumbs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.homeIcon {\n  scale: 0.85;\n  fill: var(--mui-palette-grey-800);\n}\n\n.itemLabel {\n  color: var(--mui-palette-grey-800);\n  margin-top: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12px;\n  letter-spacing: 0.15px;\n}\n\n@media only screen and (max-width: 768px) {\n  .itemLabel {\n    font-size: 12px;\n    line-height: 14px;\n  }\n}\n\n.defaultLink {\n  cursor: pointer;\n}\n\n.breadcrumbSeparator {\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--mui-palette-grey-800);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `breadcrumbs_wrapper__NBhjA`,
	"homeIcon": `breadcrumbs_homeIcon__07Fsb`,
	"itemLabel": `breadcrumbs_itemLabel__YMmC4`,
	"defaultLink": `breadcrumbs_defaultLink__TXzi8`,
	"breadcrumbSeparator": `breadcrumbs_breadcrumbSeparator__mNu3A`
};
export default ___CSS_LOADER_EXPORT___;
